import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useProductsHistoryReport } from "../../hooks/useProductsHistoryReport";
import { useDownloadProductsHistoryReportCsv } from "../../hooks/useDownloadProductsHistoryReportCsv";
import { productsHistoryReportColumns } from "../ProductsHistoryReportColumns/ProductsHistoryReportColumns";
import ProductsHistoryReportFilters from "../ProductsHistoryReportFilters/ProductsHistoryReportFilters";
import { ProductsHistoryReportItem } from "../../api/fetchProductsHistoryReport/types";

const columns = productsHistoryReportColumns();

const ProductsHistoryReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useProductsHistoryReport();

  const { loading: csvLoading, downloadCsv } =
    useDownloadProductsHistoryReportCsv();

  return (
    <MainPageWrapper title="Products History Report">
      <ProductsHistoryReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />
      <DataTable<ProductsHistoryReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No product purchases found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default ProductsHistoryReportPage;
